import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "../AdminMenu";
import AdminHeader from "../AdminHeader";
import axios from "axios";
import { ADMIN_API_BASE } from "../../../utils/apiConfig";

const AdminCheatsheetMain = () => {
    const [courses, setCourses] = useState([]);

    const getCsrfToken = async () => {
        try {
            const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            return data.csrfToken;
        } catch (error) {
            console.error('Error fetching CSRF token:', error);
            return null;
        }
    };

    useEffect(() => {
        const fetchCourses = async () => {
            const token = await getCsrfToken();
            try {
                const response = await axios.get(`${ADMIN_API_BASE}/course`, {
                    withCredentials: true,
                    headers: {
                        'csrf-token': token,
                    },
                });
                const courses = response.data.data.filter(item => item.id);
                setCourses(courses);
                console.log(response.data);
            } catch (error) {
                console.error('There was a problem with the axios request:', error);
            }
        };

        fetchCourses();
    }, []);

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='تقلب‌نامه'/>
                        <div className='w-full flex gap-4 py-3 px-10 flex-1 my-10'>
                            {courses && courses.length > 0 && courses.map(course => (
                                <div key={course.id} className="w-1/4">
                                    <Link to={`/admin/course/${course.id}/cheatsheet/`} className="block">
                                        <div
                                            className="bg-white p-5 shadow-md rounded-sm transition hover:bg-gray-100 hover:-translate-y-2">
                                            <h2 className="text-md line-clamp-2 mb-5">{course.id}</h2>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminCheatsheetMain;